import Channel from '@shared/classes/channel';
import EpgEvent from '@shared/classes/epgEvent';
import Plan from '@shared/classes/plan';
import { createContext, MutableRefObject } from 'react';

const ChannelListContext = createContext<{
  channel: Channel | undefined;
  complete: boolean;
  event: EpgEvent | undefined;
  focused?: boolean;
  index: number;
  plan: Plan | null;
  futureEvents: boolean;
  pastEvents: boolean;
}>({
  channel: undefined,
  complete: true,
  event: undefined,
  focused: false,
  index: 0,
  plan: null,
  futureEvents: false,
  pastEvents: false,
});

export default ChannelListContext;
